<template>
    <Button :label="dataRelation ? $t('assign_customer_vendor') :$t('assign_to_transporter')" icon="pi pi-check-circle" class="p-button-success p-button-sm mr-2" @click="onShowMergeModal" />

    <CustomSidebar v-model:visible="showMergeModal" position="bottom" :dismissable="false" :title="dataRelation ? $t('assign_customer_vendor') : $t('assign_to_transporter')" class="p-1" :blocked="blocked">
        <template #actions>
            <Button icon="pi pi-save" class="p-button p-button-success mr-1" :label="dataRelation ? $t('assign_customer_vendor') : $t('assign_to_transporter')" @click="save()" :disabled="dataRelation ? false : !checkedApproval"></Button>
        </template>
 
        <div class="flex" style="width:calc(100% - 2rem)">
            <div class="col-4 md-4 p-fluid">
                <div class="p-inputgroup">
                    <CustomChips v-model="addSAPNo" :allowDuplicate="false" :disabled="hasOrder"/>
                    <Button icon="pi pi-plus" class="p-button-primary" @click="clickAddSAPNo" :disabled="hasOrder || dalamPabrik"/>
                </div>

                <Message severity="error" :closable="true" v-if="addSAPNoMessage" @close="closeAddSAPMessage">{{addSAPNoMessage}}</Message>

                <TabView v-if="sapOrders" >
                    <TabPanel v-for="order in sapOrders" :key="order.Id" :header="order.Document_No + (order.Item_No ? '/' + order.Item_No : '')">
                        <ScrollPanel style="width:100%;height:70vh">
                            <ModalDataSAPOrder :data="order" v-if="order"/>
                        </ScrollPanel>
                    </TabPanel>
                </TabView>                
            </div>
            <Divider layout="vertical" />
            <div class="col-8 md-8 p-fluid">
                <div class="grid">
                   <div class="col-10">
                        <FormField :labelName="$t('show_conversion')" fieldName="Loading_Destination_To_Id" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                        <!-- <CustomSelect class="p-inputtext-sm" v-model="assignModel.loading_destination_to_id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="assignModel" :filter="true" :disabled="orderLinkSTO || blockDestination || disableInput || validateAutoAssign" @change="resetTransporter"/> -->
                        <YNCheckbox v-model="showConversionType" v-if="assignModel" :binary="true" />
                    </FormField>
                    </div>
                    <div class="col-2">
                        <div style="float:right">
                            <Button label="Sync" class="p-button-help mr-2" @click="syncDOSAP" />

                        </div>
                    </div>
                </div>

                <ScrollPanel style="width:100%;height: 70vh">
                    <DataTable :value="sapOrdersDetail ? sapOrdersDetail : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                        <Column field="is_additional">
                            <template #body="slotProps">
                                <Button icon="pi pi-plus" class="p-button p-button-warning mr-1" @click="addAdditionalDetail(slotProps.data)" v-if="slotProps.data && !slotProps.data.is_additional"></Button>
                                <Button icon="pi pi-minus" class="p-button p-button-danger mr-1" @click="deleteAdditionalDetail(slotProps.data)" v-if="slotProps.data && slotProps.data.is_additional"></Button>
                            </template>
                        </Column>
                        <Column field="include_merge"  key="include_merge">  
                            <template #body="slotProps">
                                <Checkbox v-model="slotProps.data.include_merge" :binary="true"  />
                            </template>
                        </Column>
                        <Column field="charge_oa_company" :header="$t('charge_oa_company')" key="Active" style="width:15%">
                            <template #body="slotProps">
                                <CustomSelect class="p-inputtext-sm w-10rem" v-model="slotProps.data.charge_oa_company" :url="this.$API_URL + 'list/company_code'" :minLength="0" :params="{ }" v-if="slotProps.data" :filter="true" @change="onChangeCompany($event, slotProps.index)"/>
                            </template>
                        </Column>
                        <Column field="Conversion_Type" :header="$t('conversion')" key="Active" style="width:15%">
                            <template #body="slotProps">
                                <CustomSelect class="p-inputtext-sm w-10rem" v-model="slotProps.data.conversion_type" :url="this.$API_URL + 'list/conversion_type'" :minLength="0" :params="{ company_code: slotProps.data.charge_oa_company, factory_code:  warehouseCode }" v-if="slotProps.data" :filter="true"  @change="onChangeConversionType($event, slotProps.index)"/>
                            </template>
                        </Column>
                        <Column field="ln_type" :header="$t('ln_type')">
                            <template #body="slotProps">
                                <InputText class="p-inputtext-sm" v-model="slotProps.data.ln_type"  :disabled="slotProps.data.disable_ln_type"/>
                            </template>
                        </Column>
                        <Column field="incoterm_rule" :header="$t('incoterm_rule')">
                            <template #body="slotProps">
                                <CustomSelect class="p-inputtext-sm" v-model="slotProps.data.incoterm_rule" :url="this.$API_URL + 'list/incoterm_rule'" :minLength="0" :params="{ ln_type: slotProps.data.ln_type }" :filter="true" :disabled="!slotProps.data.require_ln_inco_rule"/>
                            </template>
                        </Column>
                        <Column field="Document_No" :header="$t('sap_no')"></Column>
                        <Column field="Item_No" :header="$t('item_no')" key="Item_No">  
                        </Column>
                        <Column field="material_name" header="Material" key="material_name">
                            <template #body="slotProps">
                                <div style="text-overflow:ellipsis" class="overflow-hidden white-space-nowrap w-20rem" v-tooltip.top="slotProps.data.material_name" type="text" >
                                    {{slotProps.data.material_name}}
                                </div>
                            </template>
                        </Column>
                        <Column field="Qty" :header="$t('qty')" key="Active" style="width:15%">
                            <template #body="slotProps">
                                <InputNumber v-model="slotProps.data['Qty']" :max="maxQtyAllowed(slotProps.data)" :disabled="disableQtyInput" class="w-10rem" @blur-data="onChangeQty($event, slotProps.index)"/>
                            </template>
                        </Column>
                        <Column field="os_qty" :header="$t('os_qty')" key="Active" style="width:15%">
                            <template #body="slotProps">
                                {{this.$formatNumber(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                        <Column field="UOM" header="UOM" key="Active" style="width:10%">
                        </Column>
                         <Column field="SO_Factory_No" :header="$t('so_factory_no')" v-if="useDO ||useSO"  style="width:15%">
                            <template #body="slotProps">
                                <InputText name="SO_Factory_No" v-model="slotProps.data.SO_Factory_No" type="text" @change="setRequireSync()" class="w-10rem" />
                            </template>
                        </Column>
                        <Column field="SO_Factory_Item_No" :header="$t('so_factory_item_no')" v-if="useDO || useSO"  style="width:15%">
                            <template #body="slotProps">
                                <InputText name="SO_Factory_Item_No" v-model="slotProps.data.SO_Factory_Item_No" type="text" @change="setRequireSync()" class="w-5rem"  modelValue=""/>
                            </template>
                        </Column>
                        <Column field="SO_Factory_Result" :header="$t('result')" v-if="(useDO || useSO)">
                        </Column>
                        <Column field="SO_Factory_Result_Reason" :header="$t('remarks')" v-if="(useDO || useSO)">    
                        </Column>
                        <Column field="PO_SO_Factory" :header="$t('po_so_factory')" v-if="useDO || useSO">    
                        </Column>
                    </DataTable>

                    <Divider />

                     <AssignTransporter 
                        ref="assignTransporter"
                        :transporters="transporters" 
                        :isIndividual="isIndividual"
                        :isCollective="isCollective"
                        :isRelation="isRelation"
                        :assignModel="assignModel"
                        
                        :materials="materialDataModel"
                        :data="data"
                        :sapOrders="sapOrders"
                        @block="blockModal"
                        @unblock="unblockModal"
                        @reset-approval="onResetApproval"
                        :stuffingDateFrom="stuffingDateRangeFrom"
                        :stuffingDateTo="stuffingDateRangeTo"
                        :orderLinkSTO="orderLinkSTO"
                        :estateLocationId="estateLocationId"
                        :incoterm2DestinationId="incoterm2DestinationId"
                        :excludeTransporters="excludeTransporters"
                        :blockLoading="blockLoading"
                        :blockDestination="blockDestination"
                        :mode="$FORM_MODE_CREATE"
                        :shipmentType="shipmentType"
                        :phase2="phase2"
                        :requireLNIncoRule="requireLNIncoRule"
                        :disableLNType="disableLNType"
                        :orderTypeData="orderTypeData"
                        :disableRouteTenderNo="disableRouteTenderNo"
                        :hideTenderNo="hideTenderNo"
                        :showSTOSPOPerShipment="showSTOSPOPerShipment"
                        :allowMultipleWeighing="allowMultipleWeighing"
                        />

                    <Divider />

                    <FormField :labelName="'Approval Matrix'" fieldName="" v-model="approvalMatrixList" :skeleton="false" fieldClass="col-2">
                        <Button class="p-button-primary" @click="onCheckApproval" label="Check Approval"/>
                    </FormField>


                    <div v-if="checkedApproval">
                        <FormField :labelName="''" fieldName="" v-model="approvalMatrixList" :skeleton="false" fieldClass="col-10">
                            <DataTable 
                                v-model:selection="selectedApproval" 
                                :value="approvalMatrixList" 
                                responsiveLayout="scroll" 
                                class="p-datatable-sm editable-cells-table"
                                v-model:expandedRows="expandedRows"
                                @rowExpand="onRowExpand"
                                >
                                <Column selectionMode="single" :exportable="false" :sortable="false" headerStyle="white-space:nowrap"  :expander="true">
                                </Column>
                                <Column field="approval_matrix.Company_Code" :header="$t('company')" key="Slot_Name">  
                                </Column>
                                <Column field="approval_matrix.Business_Segment_Code" :header="$t('product_category')">
                                </Column>
                                <Column field="approval_matrix.Order_Type" :header="$t('order_type')" key="Time_From">
                                </Column>
                                <Column field="approval_matrix.Purchase_Organization_Code" :header="$t('purchase_org')" key="Time_From">
                                </Column>
                                <Column field="approval_matrix.Document_Type" :header="$t('document_type')" key="Time_From">
                                </Column>
                                <Column field="approval_matrix.Distribution" :header="$t('distribution')" key="Time_From">
                                </Column>
                                <template #expansion="slotProps">
                                <div class="orders-subtable" style="width:50vw!important">
                                    <DataTable :value="slotProps.data.approvers" style="position:sticky!important">
                                        <Column field="Username" :header="$t('username')"></Column>
                                        <Column field="fullname" :header="$t('fullname')"></Column>
                                        <Column field="Level" :header="$t('level')"></Column>
                                        <Column field="Info1" :header="$t('info1')"></Column>
                                    </DataTable>
                                </div>
                            </template>
                            </DataTable>
                        </FormField> 
                    </div>

                </ScrollPanel>
            </div>
        </div>
    </CustomSidebar>    
</template>
<script>
    import ModalDataSAPOrder from '../Helper/_ModalDataSAPOrder.vue'
    import AssignTransporter from './_AssignTransporter.vue'

    export default{
        components: {
            'ModalDataSAPOrder': ModalDataSAPOrder,
            'AssignTransporter': AssignTransporter
        },
        emits:['close'],
        props:{
            data: {
                type: Object,
                default: null
            },
            dataRelation:{
                type: Boolean,
                default:null
            }
        },
        data(){
            return{
                showMergeModal: false,
                orderData: null,
                sapOrders: [],
                sapOrdersDetail: [],
                dataUrl: "saporder/",
                blocked:false,
                addSAPNo: [],
                addSAPNoMessage: "",
                assignModel: null,
                orderType: "",
                warehouseCode: "",
                shipmentType: "",
                documentType: "",
                transporterCode: "",
                companyCode: "",
                incoterm: "",
                isFirst: true,
                freightDate: null,
                showTransporterModal: false,
                isIndividual: false,
                isCollective: false,
                isRelation: this.dataRelation,
                transporters: [],
                transportersList: [],
                sapTransporter: false,
                selectTransporterNumTrip: 1,
                stuffingDate: [],
                relationTransporter: "",
                stuffingDateRangeFrom: null,
                stuffingDateRangeTo: null,
                orderLinkSTO: false,    
                estateLocationId: null,
                incoterm2DestinationId: null,
                hasOrder: false,
                excludeTransporters: "",
                blockLoading: false,
                blockDestination: false,
                useLN: false,
                phase2: false,
                requireLNIncoRule: false,
                disableLNType: true,
                dalamPabrik: false,
                
                orderTypeData: null,
                requireSync: false,
                syncSAPSuccess: false,

                checkedApproval: false,
                approvalMatrixList: [],
                selectedApproval: null,
                expandedRows: [],

                disableRouteTenderNo: false,
                hideTenderNo:false,
                showConversionType: "N",
                showSTOSPOPerShipment:false,
                allowMultipleWeighing: false,
            }
        },
        mounted(){
            
        },
        methods:{
            reset(){
                this.orderData = null;
                this.sapOrders = [];
                this.sapOrdersDetail = [];
                this.addSAPNo = [];
                this.addSAPNoMessage= "";
                this.orderType = "";
                this.warehouseCode = "";
                this.shipmentType = "";
                this.documentType = "";
                this.companyCode = "";
                this.incoterm = "";
                this.isFirst = true;
                this.useLN = false;
                this.useSTO = false;
                this.relationTransporter = "";

                this.orderLinkSTO = false;
                this.isRelation = false;

                this.transporters = [];
                this.transportersList = [];
                this.estateLocationId = null;
                this.incoterm2DestinationId = null;

                this.hasOrder = false;
                this.excludeTransporters = "";

                this.orderTypeData = null;
                this.checkedApproval = false;
                this.approvalMatrixList = [];
                this.selectedApproval = null;

                this.showConversionType = "N";

                this.showSTOSPOPerShipment = false;
            },
            blockModal(){
                this.blocked = true;
            },
            unblockModal(){
                this.blocked = false;
            },
            onShowMergeModal(){
                this.reset();
            
                this.blocked = false;
                this.showMergeModal = true;
                this.addSAPNo.push(this.data.Document_No);
                this.onAddSAPNo();
            },
            closeAddSAPMessage(event){
                this.addSAPNoMessage = "";
            },
            showError(summary, message) {
                this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 120000});
            },
            showWarning(summary, message) {
                this.$toast.add({ severity: 'warn', summary: summary, detail: message, life: 120000});
            },
            validation(){
                 var loading = this.assignModel.loading_destination_from_id;
                var destination = this.assignModel.loading_destination_to_id;
                var chargeOACompany = this.assignModel.charge_oa_company;
                var freightDate = this.assignModel.freight_date;
                var stuffingDate = this.assignModel.stuffing_date;

                if(loading == 0){
                    this.showError("Error", this.$t('alert.require_loading')); //({ severity: 'error', summary: "Error", detail: this.$t('alert.require_loading'), life: 120000});
                    return false;
                }

                if(destination == 0){
                    this.showError("Error", this.$t('alert.require_destination')); 
                    return false;
                }

                if(!chargeOACompany){
                    this.showError("Error", this.$t('alert.require_charge_oa_company'));
                    return false;
                }

                if(!freightDate){
                    this.showError("Error", this.$t('alert.require_freight_date'));
                    return false;
                }

                if(stuffingDate == null || stuffingDate.length == 0){
                    this.showError("Error", this.$t('alert.require_stuffing_date'));
                    return false;
                }

                if(this.assignModel.transporters == null || this.assignModel.transporters.length == 0){
                    this.showError("Error", this.$t('alert.require_transporter'));
                    return false;
                }

                for(var x = 0; x< this.assignModel.transporters.length;x++){
                    if(!this.assignModel.transporters[x].transporter_code){
                        this.showError("Error", `Item ${x+1}: ` + this.$t('alert.require_transporter'));
                        return false;
                    }
                }

                return true;
            },
            save(){
                this.assignModel.transporters = this.transporters;
                this.assignModel.details = this.sapOrdersDetail;
                this.assignModel.id = this.orderList;
                this.blocked = true;
                this.assignModel.approval_matrix = this.selectedApproval;
                this.assignModel.show_conversion_type = this.showConversionType;

                if(!this.validation()){
                    this.blocked=false;
                    return;
                }

                if((this.useDO || this.useSO) && this.requireSync){
                    if(!this.syncSAPSuccess)
                    {
                        self.showError('Error Saving Data', 'NOT OK');
                        return;
                    }
                }

                if(this.assignModel.stuffing_date == null || this.assignModel.stuffing_date[1] == null){
                    this.assignModel.stuffing_date[1] = this.assignModel.stuffing_date[0];
                }

                var self = this;

                this.$axios.post(this.$API_URL + this.dataUrl + "assign_transporter", this.assignModel)
                    .then((response) =>{
                        if (response.data.success) {
                            self.$emit('close');
                            self.$parent.$toast.add({ severity: 'success', summary: "Success", detail: response.data.message, life: 120000});
                            self.showModal = false;
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                        self.blocked = false;
                    })
                    .catch((err) => {
                        //console.log(err);
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        self.showModal = false;
                    });
            },
            // disableQtyInput(event){
            //     return this.isCollective || this.useLN; //|| (!event.data.collective_ln && this.orderType == "LN");
            // },
            clickAddSAPNo(){
                var self = this;
                this.transporters = [];

                this.isFirst = true;

                this.onAddSAPNo();
            }, 
            onAddSAPNo(){
                this.blocked = true;

                var data = {
                    sap_no: this.addSAPNo,
                    warehouse_code: this.warehouseCode,
                    order_type: this.orderType,
                    shipment_type: this.shipmentType,
                    document_type: this.documentType,
                    transporter_code: this.transporterCode,
                    company_code: this.companyCode,
                    incoterm: this.incoterm,
                    is_first: this.isFirst,
                    is_edit: false
                };

                var self = this;

                self.onResetApproval();
                // console.log(data)
                // return;

                //1233000001136, 1233000001133
                this.$axios.post(this.$API_URL + this.dataUrl + "merge_simulate", data)
                    .then((response) => {
                        if (response.data.success) {
                            self.sapOrders = response.data.data.sap_orders;
                            self.sapOrdersDetail = response.data.data.sap_order_details;
                            self.stuffingDateRangeFrom = response.data.data.stuffing_date_from_range;
                            self.stuffingDateRangeTo = response.data.data.stuffing_date_to_range;
                            // self.incoterm2DestinationId = response.data.data.incoterm2_destination_id;
                            // self.estateLocationId = response.data.data.estate_location_id;
                            self.hasOrder = response.data.data.has_order;
                            self.excludeTransporters = response.data.data.exclude_transporters;
                            self.useLN = response.data.data.use_ln;
                            self.dalamPabrik = response.data.data.dalam_pabrik;

                            self.orderTypeData = response.data.data.order_type_data;

                            self.disableLNType = response.data.data.disable_ln_type;

                            self.phase2 = response.data.data.phase;

                            self.requireLNIncoRule = response.data.data.require_ln_inco_rule;

                            if(response.data.data.error_message){
                                self.addSAPNoMessage = response.data.data.error_message;
                            }

                            self.disableRouteTenderNo = response.data.data.disable_route_tender_no;
                            self.hideTenderNo = response.data.data.hide_tender_no;
                            self.showSTOSPOPerShipment = response.data.data.show_sto_spo_per_shipment;

                            
                            self.allowMultipleWeighing = response.data.data.allow_multiple_weighing;

                            // self.$nextTick(() => {
                            //     self.$refs.assignTransporter.resetTransporter();
                            // });

                            if(self.isFirst){
                                self.isFirst = false;
                                var initData = response.data.data.sap_orders[0];

                                self.orderType = initData.Order_Type;
                                self.shipmentType = initData.Shipment_Type;
                                self.warehouseCode = initData.Warehouse_Code;
                                self.documentType = initData.Document_Type;
                                self.companyCode = initData.Company_Code;
                                self.incoterm = initData.Incoterm;

                                self.isIndividual = initData.shipment_type_category == self.$SHIPMENT_TYPE_CATEGORY.INDIVIDUAL;
                                self.isCollective =  initData.shipment_type_category == self.$SHIPMENT_TYPE_CATEGORY.COLLECTIVE;
                                self.isRelation = initData.is_relation;

                                self.assignModel = response.data.data.assign_model;

                                self.assignModel.charge_oa_company = initData.Company_Code;
                                self.assignModel.warehouse_code = initData.Warehouse_Code;
                                self.assignModel.document_type = initData.Document_Type;
                                self.assignModel.ln_type = response.data.data.ln_type;
                                self.assignModel.ln_inco_rule = response.data.data.ln_inco_rule;

                                // if(initData.estate_location_id)
                                //     self.assignModel.loading_destination_from_id = initData.estate_location_id;

                                // self.assignModel.loading_destination_from_id = initData.default_loading_destination_from_id;
                                // self.assignModel.loading_destination_to_id = initData.default_loading_destination_to_id;

                                if(self.isIndividual || self.isRelation){
                                    var det = { ...self.assignModel.transporters };
                                    self.transporters.push(det);
                                }

                                if(response.data.data.default_loading_destination_from_id){
                                    self.assignModel.loading_destination_from_id =response.data.data.default_loading_destination_from_id;
                                }

                                if(response.data.data.default_loading_destination_to_id){
                                    self.assignModel.loading_destination_to_id = response.data.data.default_loading_destination_to_id;
                                }  

                                self.blockLoading = initData.block_loading;
                                self.blockDestination = initData.block_destination;

                                if(self.isRelation)
                                {
                                    self.transporterCode = initData.Customer_Vendor_Code;
                                    self.transporters[0].transporter_code = initData.Customer_Vendor_Code;
                                    self.transporters[0].transporter_name = initData.customer_vendor_name;
                                    self.transporters[0].truck_type_id = initData.relation_truck_type_id;
                                    self.transporters[0].freight_cost = 0;
                                    self.transporters[0].freight_total_cost = 0;
                                    self.transporters[0].freight_total_cost_user_not = 0;
                                    self.transporters[0].freight_suggested = 0;
                                    self.transporters[0].freight_container = 0;
                                    self.transporters[0].freight_uom = "";
                                    self.transporters[0].system_not = 1;
                                    self.transporters[0].user_not = 1;
                                    self.transporters[0].freight_date = null;
                                    
                                    self.isIndividual=true;
                                }
                                else if (initData.Transporter) {
                                    self.orderLinkSTO = true;
                                    self.transporterCode = initData.Transporter;
                                    
                                    self.assignModel.loading_destination_from_id = initData.loading_destination_from_id;
                                    self.assignModel.loading_destination_to_id = initData.loading_destination_to_id;
                                    
                                    if(self.isCollective){
                                        var det = { ...self.assignModel.transporters };
                                        self.transporters.push(det);                                        
                                    }

                                    self.transporters[0].transporter_name = initData.transporter_name;
                                    self.transporters[0].truck_type_id = initData.truck_type_id;
                                    self.transporters[0].freight_cost = initData.Freight_Cost ?? 0;
                                    self.transporters[0].freight_total_cost = initData.Freight_Cost ?? 0;
                                    self.transporters[0].freight_total_cost_user_not = initData.Freight_Total_Cost ?? 0;
                                    self.transporters[0].freight_suggested = initData.Freight_Cost ?? 0;
                                    self.transporters[0].transporter_code = initData.Transporter;
                                    self.transporters[0].freight_container = initData.Freight_Cost_Per;
                                    self.transporters[0].system_not = initData.Freight_Cost_Per;
                                    self.transporters[0].freight_uom = initData.Freight_Cost_UOM;
                                    
                                    if (self.sapOrdersDetail.length > 0) {
                                        var freightMasters = [];

                                        for (var x = 0; x < self.sapOrdersDetail.length; x++)
                                        {
                                            if (self.sapOrdersDetail[x].Freight_Master) {
                                                freightMasters.push(self.sapOrdersDetail[x].Freight_Master);
                                            }
                                        }

                                        self.transporters[0].freight_master =  freightMasters.join(' | ');
                                    }
                                }

                                // if(self.incoterm2DestinationId){
                                //     self.assignModel.loading_destination_to_id = self.incoterm2DestinationId;
                                // }

                                // if(self.estateLocationId){
                                //     self.assignModel.loading_destination_from_id = self.estateLocationId;
                                // }

                                ////TESTING PURPOSE
                                // self.assignModel.loading_destination_from_id = 11734;
                                // self.assignModel.loading_destination_to_id = 13500;
                                // self.assignModel.stuffing_date = [];
                                // self.assignModel.stuffing_date.push(new Date());
                                // self.assignModel.stuffing_date.push(new Date());
                            }
                        }
                        else {
                            console.log(response.data);
                            self.addSAPNoMessage = response.data.message;
                            //self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            //self.showAssignModal = false;
                        }
                        self.blocked = false;
                        
                    })
                    .catch(function (err) {
                        console.log(err);
                        //console.log(err);
                        self.addSAPNoMessage = err;
                        //self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });


            },
            onChangeQty(event, index){
                var self = this;
                var model = this.sapOrdersDetail[index];
                model.Qty = event.valueNumber;
                this.$nextTick(() => {
                    this.$refs.assignTransporter.onQtyChange();
                });
            },
            setRequireSync(){
                var self = this;
                this.requireSync = false;

                for(var i=0; i< this.sapOrdersDetail.length;i++){
                    var detail = this.sapOrdersDetail[i];
                    if(detail.SO_Factory_No != "" && detail.SO_Factory_No != null){
                        self.requireSync =true;
                    }
                }

            },
            syncDOSAP(){
                var self = this;

                self.blocked = true;

                var data = {...this.sapOrders[0]};

                data.Details = this.sapOrdersDetail;

                var url =  this.$API_URL + "saporder/";


                 this.$axios.post(url + "sync_do_sap", data)
                    .then((response) => {
                        if(response){
                            if(response.data.data){
                                var dataResult = response.data.data;
                                self.sapOrdersDetail = dataResult;
                                if(response.data.success)
                                    self.requireSync = false;
                            }

                            self.syncSAPSuccess = response.data.success;
                            if(self.syncSAPSuccess == false){
                                self.showError('Error Sync to SAP', response.data.message + (response.data.message_code == null ? "" : ("\n" + response.data.message_code)));
                                self.requireSync = true;
                            }                 
                            else{
                                self.showWarning('Info SO Factory', (response.data.message_code == null ? "" : "\n" + response.data.message_code));
                            }           
                        }

                        self.blocked = false;
                    })
                    .catch((error) => {
                        self.showError('Error Sync to SAP', error);

                        self.blocked = false;
                    });
                self.onResetApproval();
            },
             onChangeConversionType(event, index){
                var self = this;
                this.$nextTick(() => {
                    this.$refs.assignTransporter.onQtyChange();
                });
                self.onResetApproval();
            },
            onChangeCompany(event, index){
                var self = this;
                var model = this.sapOrdersDetail[index];

                this.getDefaultConversionType(model);


                // model.Qty = event.valueNumber;
                this.$nextTick(() => {
                    this.$refs.assignTransporter.onQtyChange();
                });
                self.onResetApproval();
            },
            getDefaultConversionType(model){
                var self = this;

                
                this.$axios.get(this.$API_URL + "util/default_conversion_type/" + this.warehouseCode + "/" + model.charge_oa_company)
                    .then((response) =>{
                        if (response.data.success) {
                            self.blocked = false;
                            //self.$parent.$toast.add({ severity: 'success', summary: "Success", detail: response.data.message, life: 120000});
                            model.conversion_type = response.data.data;
                        }
                        else {
                            self.blocked = false;
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                        self.blocked = false;
                    })
                    .catch((err) => {
                        //console.log(err);
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                    });
            },
            onCheckApproval(){
                this.assignModel.transporters = this.transporters;
                this.assignModel.details = this.sapOrdersDetail;
                this.assignModel.id = this.orderList;

                 var self = this;

                 self.blocked = true;

                this.$axios.post(this.$API_URL + "util/check_approval", this.assignModel)
                    .then((response) =>{
                        if (response.data.success) {
                            self.blocked = false;
                            //self.$parent.$toast.add({ severity: 'success', summary: "Success", detail: response.data.message, life: 120000});
                            self.checkedApproval = true;
                            self.approvalMatrixList = response.data.data.approval_list;

                            if(self.approvalMatrixList.length == 1){
                                self.selectedApproval = self.approvalMatrixList[0];
                            }

                            self.transporters = response.data.data.transporter_data;
                        }
                        else {
                            self.blocked = false;
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                        self.blocked = false;
                    })
                    .catch((err) => {
                        //console.log(err);
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                    });
            },
            onRowExpand(event){
                this.expandedRows = [];
                this.expandedRows.push(event.data);
            },
            onResetApproval(){
                var self=this;
                self.checkedApproval = false;
                self.selectedApproval = null;
                self.approvalMatrixList = [];
            },
            addAdditionalDetail(data){
                var self = this;

                var copiedDetail = {...data};
                copiedDetail.is_additional = true;
                copiedDetail.mode = self.$FORM_MODE_CREATE;
                copiedDetail.Qty = 0;
                self.sapOrdersDetail.push(copiedDetail);

            },  
            deleteAdditionalDetail(data){
                var self = this;

                self.sapOrdersDetail.splice(self.sapOrdersDetail.indexOf(data), 1);
            },
            maxQtyAllowed(data){
                var max = 0;
                var self = this;

                var osQty = data.os_qty;
                var documentNo = data.Document_No;
                var itemNo = data.Item_No;

                var index = self.sapOrdersDetail.indexOf(data);

                var detailsFilter = self.sapOrdersDetail.filter(function(i) {
                    return i.Document_No == documentNo && i.Item_No == itemNo && self.sapOrdersDetail.indexOf(i) != index;
                });

                var sumQty = 0;
                for(var i=0; i< detailsFilter.length;i++){
                    var qty = detailsFilter[i].Qty;

                    sumQty += qty;
                }

                max = osQty - sumQty;

                return max;
            }
        },
        computed:{
            materialDataModel(){
                var model = [];

                for(var i =0; i< this.sapOrdersDetail.length;i++){
                    var detail = this.sapOrdersDetail[i];
                    model.push({
                        include_merge: detail.include_merge,
                        Id: detail.Id,
                        Item_No: detail.Item_No,
                        Material_Code: detail.Material_Code,
                        Material_Name: "",
                        Qty: detail.Qty,
                        UOM: detail.UOM,
                        Freight_Master: 0,
                        Freight_Cost:0,
                        Freight_Per: "",
                        Freight_UOM:"",
                        charge_oa_company: detail.charge_oa_company,
                        Conversion_Type: detail.conversion_type,
                    });
                }

                return model;
            },
            stuffingDateFrom(){
                if(this.stuffingDate.length > 0){
                    return this.$formatDate(this.stuffingDate[0]);
                }
                else return "";
            },
            stuffingDateTo(){
                if(this.stuffingDate.length>0){
                    return this.$formatDate(this.stuffingDate[1]);
                }
                else return "";
            },
            orderList(){
                var list = [];

                if(this.sapOrders.length == 0) return list;

                return this.sapOrders.map(function(v) {
                            return v.Id;
                        });
            },
            disableQtyInput(){
                return this.isCollective || this.useLN; //|| (!event.data.collective_ln && this.orderType == "LN");
            },
             useSO(){
                if(this.orderTypeData){
                    return this.orderTypeData.Use_SO;
                }
                return false;
            },
            useDO(){
                if(this.orderTypeData){
                    return this.orderTypeData.Use_DO;
                }
                return false;
            }
            
        }


    }

</script>

